import { EquipmentListScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officePmsSource } from '../pms-source.js';

/**
 * Maintenance (PMS) ▸ Equipment List (ortak ekran; M7a): ofis kurulum devrindeki gemiyi hazırlar,
 * etkin geminin ana verisini yalnız görür (K1); sayaç okuması gemide (K13).
 */
export function PmsEquipmentPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsEquipment')}>
      <EquipmentListScreen source={officePmsSource} />
    </Shell>
  );
}
